import Config from './config';

import React from 'react';
import ReactDOM from 'react-dom';

import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';

import { Router, useRouterHistory } from 'react-router';
import { createHistory } from 'history';

const history = useRouterHistory(createHistory)({ basename: '/' });

import combineActionsMiddleware  from 'redux-combine-actions';
import reduxPromiseMiddleware from 'redux-promise-middleware';
import thunk from 'redux-thunk';
import lhCometMiddleware from './middlewares/lhCommet';
import lhEmitMiddleware from './middlewares/lhEmit';
import Tawk from './services/tawk';
import WhatsHelp from './services/whatshelp';
import Cedexis from './services/cedexis';
import LeadDyno from './services/lead-dyno';

import reducers from './reducers';
import routes from './routes';

const createStoreWithMiddleware = applyMiddleware(combineActionsMiddleware, reduxPromiseMiddleware(), lhCometMiddleware(), lhEmitMiddleware(), thunk)(createStore);
const store = createStoreWithMiddleware(reducers);

if (Config.tawk && Config.tawk.version) {
  new Tawk(Config.tawk.version);
}

if (Config.whatshelp && Config.whatshelp.version) {
  new WhatsHelp(Config.whatshelp);
}

if (Config.cedexis) {
  new Cedexis(Config.cedexis);
}

if (Config.leadDyno && Config.leadDyno.version) {
  new LeadDyno(Config.leadDyno.version);
}

ReactDOM.render(<Provider store={ store }>
  <Router history={history}>
    {routes(store)}
  </Router>
</Provider>, document.getElementById('ott_web'));


// WEBPACK FOOTER //
// ./src/index.js